// Import React and ReactDOM
import React from 'react';
import ReactDOM from 'react-dom';
import Dom7 from 'dom7';

// Import Framework7
import Framework7 from 'framework7/framework7.esm.bundle';

// Import Framework7-React plugin
import Framework7React from 'framework7-react';

// Import main App component
import App from './components/App.jsx';

// Framework7 styles
import 'framework7/css/framework7.min.css';

// Icons
import './css/icons.css';

// Custom app styles
import './css/app.css';

// Init Framework7-React plugin
Framework7.use(Framework7React);

var $$ = Dom7;
let accessToken = null;
$$(document).on('page:init', function (e) {
  // Do something here when page loaded and initialized
  let page = e.detail;
  sessionStorage.setItem('accessToken', page.route.query.access_token);
})

// Mount React App
ReactDOM.render(
  React.createElement(App),
  document.getElementById('app'),
);


// WEBPACK FOOTER //
// ./src/index.js